"use client";

import { withFallback } from "../with-fallback";

export const WithdrawalsElement = withFallback({
	displayName: "WithdrawalsElement",
	type: "withdrawals-element",
} as const);
